import { z } from 'zod'

// 999 is Currency Code for Avios Points
export const CurrencyCodesSchema = z.enum(['EUR', 'GBP', 'USD', '999'])

export type CurrencyCodes = z.infer<typeof CurrencyCodesSchema>
